import axios from 'axios';
import authHeader from '../auth-header';
// Pakai tag ini kalau mau nge post file
import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getProfile = 'profile';
const putProfile = 'profile/';

class ProfileService {

    getProfile(){        
        return axios.get(
            API_URL + getProfile, 
            { headers: authHeader() 
        });
    }

    putProfile(formData) {
        var headers = authHeader(); 
        
        return axios
        .put(
            API_URL + putProfile + formData.idProfile, formData,
            { headers: authHeader() }
        );
    }

}

export default new ProfileService();
